
















import { Vue, Component, Watch } from 'vue-property-decorator';
import DollarIcon from 'mdi-vue/CurrencyUsd';
import CloseIcon from 'mdi-vue/Close';

import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Accordion from '@/components/Accordion.vue';
import Loader from '@/components/Loader.vue';
import ToggleLanguage from '@/components/ToggleLanguage.vue';

import { State } from '@/store/disbursementManagement';

import { mapState } from 'vuex';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import api from '@/libs/api';
import topupLocale from '@/locale/topup';

import BalanceBox from './BalanceBox.vue';

@Component({
  components: {
    LayoutContent,
    Button,
    Loader,
    BalanceBox,
    Accordion,
    DollarIcon,
    CloseIcon,
    ToggleLanguage,
  },
  computed: mapState(['disbursementManagement']),
})
export default class BalanceJumbotron extends Vue {
  disbursementManagement!: State;
  showModalVa = false;

  loadingVaNumber = true;
  numbers: { [key: string]: string } = {};

  language = false;
  locale = topupLocale.en;

  // mounted() {
  //   this.getVaNumber();
  // }

  @Watch('language')
  changeLanguage() {
    this.locale = topupLocale[this.language ? 'id' : 'en'];
  }

  async getVaNumber() {
    try {
      this.loadingVaNumber = true;
      const { data } = await api.get('/disbursement/summary-api/summary/revenue');
      this.numbers = data;
      this.loadingVaNumber = false;
      // console.log(data);
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'Failed to get Virtual Account number');
    }
  }
}
